import styled from 'styled-components';
import { GRUNDFOS_BLUE, BLUE1, BLUE2, BLUE3, ATTENTION_BLUE, RED3 } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE, FONT_WEIGHT } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const AgentDomainSelector = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 480px;
  margin-bottom: 32px;
`;

export const AgentDomainSelector__Label = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  margin: 0 0 4px 0;
  text-align: center;
`;

export const AgentDomainSelector__Buttons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;

  ${MEDIA.MOBILE} {
    gap: 12px;
  }
`;

export const AgentDomainSelector__DomainBtn = styled.button<{
  $active: boolean;
  $disabled?: boolean;
}>`
  min-width: 120px;
  padding: 14px 28px;
  border-radius: 12px;
  border: 2px solid
    ${(props) => (props.$active ? GRUNDFOS_BLUE : BLUE2)};
  background: ${(props) => (props.$active ? GRUNDFOS_BLUE : BLUE1)};
  color: ${(props) => (props.$active ? '#ffffff' : GRUNDFOS_BLUE)};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: ${FONT_SIZE.LARGE};
  font-weight: ${FONT_WEIGHT.BOLD};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
  transition: all 0.25s ease;
  letter-spacing: 0.04em;

  &:hover {
    border-color: ${(props) => (props.$disabled ? undefined : ATTENTION_BLUE)};
    background: ${(props) =>
      props.$disabled ? undefined : props.$active ? GRUNDFOS_BLUE : '#dce9f4'};
    transform: ${(props) => (props.$disabled ? 'none' : 'translateY(-2px)')};
    box-shadow: ${(props) => (props.$disabled ? 'none' : '0 6px 20px rgba(0, 0, 0, 0.12)')};
  }

  &:active {
    transform: translateY(0);
  }

  ${MEDIA.MOBILE} {
    min-width: 100px;
    padding: 12px 20px;
    font-size: ${FONT_SIZE.MEDIUM};
  }
`;

export const AgentDomainSelector__ActiveTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: ${BLUE1};
  border: 1px solid ${BLUE2};
  border-radius: 20px;
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.SMALL};
`;

export const AgentDomainSelector__ActiveTagDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${ATTENTION_BLUE};
  display: inline-block;
  flex-shrink: 0;
`;

export const AgentDomainSelector__BlockedNotice = styled.p`
  color: ${RED3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  margin: 4px 0 0 0;
  text-align: center;
`;

/* ── Header variant ────────────────────────────────────────────────────────
  Shared domain selector controls rendered in ChatHeader.
   ──────────────────────────────────────────────────────────────────────── */

export const AgentDomainHeader__Group = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  border: 2px solid ${GRUNDFOS_BLUE};
  border-radius: 8px;
  overflow: hidden;
  margin-left: 8px;
`;

export const AgentDomainHeader__Badge = styled.span`
  padding: 0 8px;
  height: 30px;
  display: flex;
  align-items: center;
  background: ${GRUNDFOS_BLUE};
  color: #ffffff;
  font-family: ${FONT_FAMILY.EXTRA_BOLD};
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  user-select: none;
  flex-shrink: 0;
`;

export const AgentDomainHeader__DomainBtn = styled.button<{ $active: boolean; $disabled?: boolean }>`
  padding: 0 14px;
  height: 30px;
  border: none;
  border-left: 1px solid ${GRUNDFOS_BLUE};
  background: ${(props) => (props.$active ? GRUNDFOS_BLUE : '#ffffff')};
  color: ${(props) => (props.$active ? '#ffffff' : GRUNDFOS_BLUE)};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: ${FONT_SIZE.SMALL};
  letter-spacing: 0.06em;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
  transition: background 0.18s ease, color 0.18s ease;

  &:hover {
    background: ${(props) =>
      props.$disabled ? undefined : props.$active ? GRUNDFOS_BLUE : BLUE1};
  }

  ${MEDIA.MOBILE} {
    padding: 0 10px;
    font-size: 12px;
  }
`;
